<span *ngIf="listaCarrito" [matBadge]="listaCarrito.length" matBadgeOverlap="true" class="cursor"
  (click)="shoppingCart()">
  <fa-icon [icon]="['fas', 'shopping-cart']" [fixedWidth]="true" size="lg">
  </fa-icon>
</span>
